import $ from 'jquery';
import JSZip from 'jszip';
import DataTable from 'datatables.net-bs5';
import 'datatables.net-buttons';
import 'datatables.net-buttons/js/buttons.html5.mjs';
import 'datatables.net-buttons/js/buttons.print.mjs';

DataTable.Buttons.jszip(JSZip);

window.$ = $;
window.jQuery = $;
window.DataTable = DataTable;
window.JSZip = JSZip;
globalThis.DataTable = DataTable;
globalThis.JSZip = JSZip;
